import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Warning from "@material-ui/icons/Warning";
import Error from "@material-ui/icons/Error";
import Info from "@material-ui/icons/Info";

// core components
import Snackbar from "components/Snackbar/Snackbar.jsx";

const styles = theme => ({
  // Add any custom styles if needed
});

class LicenseSnackbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSnackbar: false,
      snackbarMessage: "",
      snackbarColor: "info",
      snackbarIcon: Info,
    };
    this.alertTimeout = null;
  }

  componentDidMount() {
    this.checkLicenseNotifications();
  }

  componentWillUnmount() {
    this.clearAlertTimeout();
  }

  clearAlertTimeout = () => {
    if (this.alertTimeout !== null) {
      clearTimeout(this.alertTimeout);
    }
  };

  showNotification = (message, color = "info", icon = Info) => {
    this.setState({
      showSnackbar: true,
      snackbarMessage: message,
      snackbarColor: color,
      snackbarIcon: icon,
    });
    
    this.clearAlertTimeout();
    this.alertTimeout = setTimeout(
      function() {
        this.setState({ showSnackbar: false });
      }.bind(this),
      6000 // Show for 6 seconds
    );
  };

  checkLicenseNotifications = () => {
    const { locationLicenses } = this.props;
    
    if (!locationLicenses || !Array.isArray(locationLicenses)) {
      return;
    }

    // Check for expired licenses
    const expiredLicenses = locationLicenses.filter(
      loc => loc.license && loc.license.isValid === 0
    );

    // Check for licenses expiring within 30 days
    const expiringLicenses = locationLicenses.filter(
      loc => loc.license && 
             loc.license.isValid === 1 && 
             loc.license.daysUntilExpiration !== null &&
             loc.license.daysUntilExpiration <= 30 &&
             loc.license.daysUntilExpiration > 0
    );

    // Show expired license notification first (highest priority)
    if (expiredLicenses.length > 0) {
      this.showExpiredLicenseNotification(expiredLicenses);
    }
    // Show expiring license warning if no expired licenses
    else if (expiringLicenses.length > 0) {
      this.showExpiringLicenseNotification(expiringLicenses);
    }
  };

  showExpiredLicenseNotification = (expiredLicenses) => {
    const locationNames = expiredLicenses.map(loc => loc.locationName).join(", ");
    const message = `License expired for: ${locationNames}.`;
    
    this.showNotification(
      message,
      "danger",
      Error
    );
  };

  showExpiringLicenseNotification = (expiringLicenses) => {
    const notifications = expiringLicenses.map(loc => {
      const days = loc.license.daysUntilExpiration;
      return `${loc.locationName} (${days} days)`;
    });
    
    const message = `License renewal due soon for: ${notifications.join(", ")}.`;
    
    this.showNotification(
      message,
      "warning",
      Warning
    );
  };

  // Public method to manually trigger notifications (for future use)
  triggerLicenseCheck = () => {
    this.checkLicenseNotifications();
  };

  render() {
    const { classes } = this.props;
    const { showSnackbar, snackbarMessage, snackbarColor, snackbarIcon } = this.state;

    return (
      <Snackbar
        place="tc" // top center
        color={snackbarColor}
        icon={snackbarIcon}
        message={snackbarMessage}
        open={showSnackbar}
        closeNotification={() => this.setState({ showSnackbar: false })}
        close
      />
    );
  }
}

LicenseSnackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  locationLicenses: PropTypes.arrayOf(
    PropTypes.shape({
      locationId: PropTypes.number.isRequired,
      locationName: PropTypes.string.isRequired,
      license: PropTypes.shape({
        isValid: PropTypes.number, // 0 = invalid, 1 = valid (SQL Server BIT type)
        daysUntilExpiration: PropTypes.number,
        expirationDate: PropTypes.string,
      }),
    })
  ),
};

export default withStyles(styles)(LicenseSnackbar);



// WEBPACK FOOTER //
// ./src/components/LicenseNotifications/LicenseSnackbar.jsx